export const rewardTypeOptions = [
    "trade",
    "savings",
    "course_completion",
    "social_first_post",
];
